import styled from 'styled-components';

export const Wrapper = styled.div({
  display: 'inline-flex',
  alignItems: 'center',
});

export const StatusStyled = styled.span(({ theme }) => {
  return {
    fontWeight: theme.font.weight.xbold,
    marginRight: theme.font.size.small,
  };
});

export const StatusIndicator = styled.small`
  display: inline-block;
  width: ${props => props.theme.spacing.default};
  height: ${props => props.theme.spacing.default};
  background-color: ${props => props.color};
  border-radius: 100%;
  margin-left: ${props => props.theme.spacing.small};
  vertical-align: middle;
`;
